<template>
  <ClientOnly>
    <Teleport v-if="!inListing" to="#pano" noinline>
      <slot />
    </Teleport>
  </ClientOnly>
</template>

<script setup lang="ts">
const inListing = inject('inListing', false)
</script>

<style lang="postcss"></style>
